export default {
  metricManagerApi: {
    metric: {
      getList: '/api/metric/metric/getList',
      getDataPoints: '/api/metric/metric/getDataPoints',
      getValTypes: '/api/metric/metric/getValTypes'
    },
    datasource: {
      getList: '/api/realmetric/datasource/getList',
      getOptions: '/api/realmetric/datasource/getOptions',
    },
    realMetric: {
      getList: '/api/realmetric/realmetric/getList',
    },
    controllableMetric: {
      getList: '/api/realmetric/controllableMetric/getList',
      doCommand: '/api/realmetric/controllableMetric/doCommand',
      getCtrlRecord: '/api/realmetric/controllableMetric/getCtrlRecord',
    },
    virtualmetric: {
      getList: '/api/virtualmetric/getList',
      getSubVmList: '/api/virtualmetric/getSubVmList',
      getFatherOptions: '/api/virtualmetric/getFatherOptions',
      saveMetric: '/api/virtualmetric/saveMetric',
      updateMetric: '/api/virtualmetric/updateMetric',
      del: '/api/virtualmetric/del',
      export: '/api/virtualmetric/export',
      exportTemp: '/api/virtualmetric/exportTemp',
      import: '/api/virtualmetric/import'
    },
    complexMetric: {
      getList: '/api/complexMetric/getList',
      saveMetric: '/api/complexMetric/saveMetric',
      updateMetric: '/api/complexMetric/updateMetric',
      del: '/api/complexMetric/del',
      export: '/api/complexMetric/export',
      exportTemp: '/api/complexMetric/exportTemp',
      import: '/api/complexMetric/import',
      simple: '/api/complexMetric/simple',
      simpleByTime: '/api/complexMetric/simpleByTime',
      simpleByRange: '/api/complexMetric/simpleByRange',
    }
  }
}